import { Order } from "../../../../graphics/tables/operations/sort";
import { ApiDatasource } from "../../adapters/io/datasources/ApiDatasource";
import { unwrap } from "../../adapters/io/network/HttpResponse";
import { formatText } from "../../adapters/io/network/utils";
import { ApiDatasourceSpec } from "../../core/datasource";
import { AuthState } from '@okta/okta-auth-js';
import { buildHeader } from './utils/Utils';
import { DgCompliantPpsTableStructure } from "../indexes/DgCompliantPpsIndexes";
// import { DgCompliantPpsAuditTableStructure } from "../indexes/DgCompliantPpsAuditIndexes";

export const searchDgCompliantPps = <T>(
    authState: AuthState,
    search: DgCompliantPpsTableStructure.FormattedSearchValue[],
    page?: number,
    limit?: number,
    order?: Order,
    orderBy?: string | number,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<DgCompliantPpsTableStructure.ResponseOf<T>> => {
    const params = new Map();
    const body = {
        fieldSearches: search
    };
    page !== undefined && params.set('page', page);
    limit !== undefined && params.set('limit', limit);
    order !== undefined && params.set('order', order);
    orderBy !== undefined && params.set('orderBy', orderBy);

    return datasource.remote
        .postData<DgCompliantPpsTableStructure.ResponseOf<T>, DgCompliantPpsTableStructure.ListOfFormattedSearchValue>(
            uriFormatter(EndpointDgCompliantPps.endPoint.concat(EndpointDgCompliantPps.searchDgCompliantPps), {}),
            body, buildHeader(authState), params)
        .then(unwrap);
};

export const getDgCompliantPpsColumnInformation = <T>(
    authState: AuthState,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<DgCompliantPpsTableStructure.ResponseOfColumn<T>> => {
    const params = new Map();

    return datasource.remote
        .getData<DgCompliantPpsTableStructure.ResponseOfColumn<T>>(
            uriFormatter(EndpointDgCompliantPps.endPoint.concat(EndpointDgCompliantPps.getDgCompliantPpsColumnInformation), {}),
            buildHeader(authState), params)
        .then(unwrap);
};

export const createDgCompliantPps = <RecordType>(
    authState: AuthState,
    record: RecordType,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<void> => {
    return datasource.remote
        .postData<void, RecordType>(
            uriFormatter(EndpointDgCompliantPps.endPoint.concat(EndpointDgCompliantPps.createDgCompliantPps), {}),
            record, buildHeader(authState), new Map())
        .then(() => {});
};

export const editDgCompliantPps = <RecordType>(
    authState: AuthState,
    id: string,
    record: RecordType,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<void> => {
    return datasource.remote
        .putData<void, RecordType>(
            uriFormatter(EndpointDgCompliantPps.endPoint.concat(EndpointDgCompliantPps.editDgCompliantPps), {}) + `?id=${id}`,
            record, buildHeader(authState), new Map())
        .then(() => {});
};

export const deleteDgCompliantPps = (
    authState: AuthState,
    id: string,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
) => datasource.remote.deleteData(
    uriFormatter(EndpointDgCompliantPps.endPoint.concat(EndpointDgCompliantPps.deleteDgCompliantPps), {}) + `?id=${id}`,
    buildHeader(authState), new Map()
);

// export const searchDgCompliantPpsAudit = <T>(
//     authState: AuthState,
//     search: DgCompliantPpsAuditTableStructure.FormattedSearchValue[],
//     page?: number,
//     limit?: number,
//     order?: Order,
//     orderBy?: string | number,
//     datasource: ApiDatasourceSpec = new ApiDatasource(),
//     uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
// ): Promise<DgCompliantPpsAuditTableStructure.ResponseOf<T>> => {
//     const params = new Map();
//     const body = {
//         fieldSearches: search
//     };
//     page !== undefined && params.set('page', page);
//     limit !== undefined && params.set('limit', limit);
//     order !== undefined && params.set('order', order);
//     orderBy !== undefined && params.set('orderBy', orderBy);
//
//     return datasource.remote
//         .postData<DgCompliantPpsAuditTableStructure.ResponseOf<T>, DgCompliantPpsAuditTableStructure.ListOfFormattedSearchValue>(
//             uriFormatter(EndpointDgCompliantPps.endPoint.concat(EndpointDgCompliantPps.searchDgCompliantPpsAudit), {}),
//             body, buildHeader(authState), params)
//         .then(unwrap);
// };
//
// export const getDgCompliantPpsAuditColumnInformation = <T>(
//     authState: AuthState,
//     datasource: ApiDatasourceSpec = new ApiDatasource(),
//     uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
// ): Promise<DgCompliantPpsAuditTableStructure.ResponseOfColumn<T>> => {
//     const params = new Map();
//
//     return datasource.remote
//         .getData<DgCompliantPpsAuditTableStructure.ResponseOfColumn<T>>(
//             uriFormatter(EndpointDgCompliantPps.endPoint.concat(EndpointDgCompliantPps.getDgCompliantPpsAuditColumnInformation), {}),
//             buildHeader(authState), params)
//         .then(unwrap);
// };

export const EndpointDgCompliantPps = {
    endPoint: '/end-point/dg-compliant-pps',
    searchDgCompliantPps: '/search',
    getDgCompliantPpsColumnInformation: '/column-information',
    createDgCompliantPps: '',
    editDgCompliantPps: '',
    deleteDgCompliantPps: '',
    searchDgCompliantPpsAudit: '/audit/search',
    getDgCompliantPpsAuditColumnInformation: '/audit'
};
